// frontend/src/components/admin/UserManager.js
import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Chip,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import api from "../../api";
import UserForm from "./UserForm";

const UserManager = () => {
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchUsers = useCallback(async () => {
    try {
      const res = await api.get(`/admin/users?search=${searchTerm}`);
      setUsers(res.data);
    } catch (err) {
      console.error("Failed to fetch users", err);
    }
  }, [searchTerm]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  // ✨ NOUVELLE LOGIQUE POUR OUVRIR LA MODALE ✨
  const handleOpenModal = (user = null) => {
    setEditingUser(user); // Si user est null, c'est une création. Sinon, c'est une édition.
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingUser(null); // Toujours réinitialiser après la fermeture
  };

  const handleSave = async (formData, id) => {
    const url = id ? `/admin/users/${id}` : "/admin/users";
    const method = id ? "put" : "post";
    try {
      await api[method](url, formData);
      alert(`Utilisateur ${id ? "mis à jour" : "créé"} avec succès !`);
      handleCloseModal();
      fetchUsers();
    } catch (err) {
      alert(
        err.response?.data?.msg ||
          `Erreur lors de la ${id ? "mise à jour" : "création"}.`
      );
    }
  };

  const handleDeleteUser = async (id) => {
    if (
      window.confirm("Êtes-vous sûr de vouloir supprimer cet utilisateur ?")
    ) {
      try {
        await api.delete(`/admin/users/${id}`);
        alert("Utilisateur supprimé avec succès.");
        fetchUsers();
      } catch (err) {
        alert(err.response?.data?.msg || "Erreur lors de la suppression.");
      }
    }
  };

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <TextField
          variant="outlined"
          placeholder="Rechercher..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
        {/* Le bouton "Créer" appelle maintenant la nouvelle fonction sans argument */}
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleOpenModal()}
        >
          Créer un Utilisateur
        </Button>
      </Box>

      {/* ✨ UN SEUL FORMULAIRE, PLUS INTELLIGENT ✨ */}
      <UserForm
        open={isModalOpen}
        handleClose={handleCloseModal}
        editingUser={editingUser}
        onSave={handleSave}
      />

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nom</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Profession</TableCell>
              <TableCell>Rôle</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user._id}>
                <TableCell>{`${user.firstName} ${user.lastName}`}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.profession}</TableCell>
                <TableCell>
                  <Chip
                    label={user.role}
                    color={user.role === "admin" ? "secondary" : "primary"}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  {/* Le bouton "Modifier" passe l'objet 'user' à la nouvelle fonction */}
                  <Button
                    sx={{ mr: 1 }}
                    variant="outlined"
                    size="small"
                    onClick={() => handleOpenModal(user)}
                  >
                    Modifier
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    color="error"
                    onClick={() => handleDeleteUser(user._id)}
                  >
                    Supprimer
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default UserManager;
